import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* ===================================================================
     * FUENTE GLOBAL DE LA APLICACIÓN
     * Este es el ÚNICO lugar donde se elige la tipografía de todo el sistema.
     * Cambia el valor de --app-font y se propaga a cada componente, porque
     * todo (CSS, styled-components, emotion y el tema de MUI) referencia
     * esta variable con var(--app-font).
     * =================================================================== */
    :root{
        --app-font: 'Metropolis', sans-serif;
        --app-font-weight: 400; /* peso base (normal); los componentes con peso propio lo sobreescriben */
        --color--primary:red;
    }

    *{
        font-family: var(--app-font);
        font-weight: var(--app-font-weight);
    }
    .flex {
        display: flex;
    }

    .noBorder {
        border-color: #FFF;
        border-width: 0;
    }

    .projectGreen {
        background-color: #00984A;
    }

    .projectDarkGray {
        color: #6D6D6D
    }

    .col {
        flex-direction: column;
    }

    /* Halo del aviso de versión nueva. La especificidad extra de
     * [data-sonner-toast] gana sobre el borde propio de sonner sin recurrir
     * a !important. */
    @keyframes toastHalo {
        0%, 100% { box-shadow: 0 0 0 1px #00984A, 0 0 12px 2px rgba(0, 152, 74, 0.45); }
        50%      { box-shadow: 0 0 0 1px #00984A, 0 0 22px 6px rgba(0, 152, 74, 0.75); }
    }

    [data-sonner-toast].toast-halo {
        border: 1px solid #00984A;
        animation: toastHalo 1.8s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
        [data-sonner-toast].toast-halo {
            animation: none;
            box-shadow: 0 0 0 1px #00984A, 0 0 16px 4px rgba(0, 152, 74, 0.6);
        }
    }
`;

export default GlobalStyle;
